export var OrganizationGenderType;
(function (OrganizationGenderType) {
    OrganizationGenderType["Mixed"] = "Mixed";
    OrganizationGenderType["Separated"] = "Separated";
    OrganizationGenderType["OnlyMale"] = "OnlyMale";
    OrganizationGenderType["OnlyFemale"] = "OnlyFemale";
})(OrganizationGenderType || (OrganizationGenderType = {}));
//# sourceMappingURL=OrganizationGenderType.js.map